module.exports = __webpack_public_path__ + "img/hr-rock-big-07.d229ccc1.png";